import { API_URL } from '@/utils/apiUrl';

export const googleLoginUrl = (next = '') => {
  if (typeof window === 'undefined') return '#';
  const callback = new URL('/auth/callback', window.location.origin);
  if (next) callback.searchParams.set('next', next);
  return `${API_URL}/api/auth/google/login?redirect_uri=${encodeURIComponent(callback.toString())}`;
};
